import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { ConfigService } from '../../services/config.service';

@Injectable()
export class RedirectGuard {
  constructor(protected configService: ConfigService, protected router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const url = state.url;
    let isRedirectLoaded = false;
    if (
      this.configService.redirects &&
      this.configService.redirects.length &&
      this.configService.redirects.length === 1
    ) {
      if (this.configService.redirects[0] && this.configService.redirects[0].redirects) {
        if (this.configService.redirects[0].redirects[url]) {
          isRedirectLoaded = true;
          if (this.configService.redirects[0].redirects[url].startsWith('/dashboard')) {
            window.location.href = this.configService.redirects[0].redirects[url];
          } else {
            this.router.navigateByUrl(this.configService.redirects[0].redirects[url]);
          }
          return false;
        }
      }
    }

    if (!isRedirectLoaded) {
      return new Observable<boolean>((observer) => {
        this.configService.getConfig('redirects').subscribe(
          (response) => {
            this.configService.redirects = response?.Items ? response.Items : null;
            observer.next(this.processRedirects(response.Items, url));
          },
          () => {
            this.configService.redirects = null;
            observer.next(true);
          }
        );
      });
    }
  }

  private processRedirects(items: any[], url: string): boolean {
    if (!items || items.length > 1) return true;
    const config = items[0];
    if (!config?.redirects) return true;
    const redirects = config.redirects;
    if (!redirects[url]) return true;
    if (redirects[url].startsWith('/dashboard')) {
      window.location.href = redirects[url];
    } else {
      this.router.navigateByUrl(redirects[url]);
    }

    return false;
  }
}
